import swal from 'sweetalert';
import Cookies from 'js-cookie';

const init = () => {
  if( !window.tafSeed && window.tafSeed.globalModal) { return; }
  if(!window.tafSeed.globalModal.showModal){ return ;}
  const {modalHeaderText, modalContent} = window.tafSeed.globalModal;
  const cookieAlertKey = `taf-alert-covid-1-${modalContent.length}`;
  var alertHasBeenViewed = Cookies.get(cookieAlertKey);
  if (alertHasBeenViewed) { return; };

  var closeButton = document.createElement('img');
  closeButton.src = 'assets/images/close-x.svg';
  closeButton.className = 'swal-closer-icon';
  closeButton.onclick = function(evt){
    swal.close()
  };
  var alertTitle = modalHeaderText;
  var alertHtml = modalContent;
  var alertContent = document.createElement('div');
  var title = document.createElement('div');
  var underline = document.createElement('div');
  underline.className = 'story-content-divider';
  var body = document.createElement('div');

  body.innerHTML = alertHtml;
  alertContent.appendChild(closeButton);
  alertContent.appendChild(title);
  alertContent.appendChild(underline);
  alertContent.appendChild(body);

  swal({ content: alertContent, button: false, title: alertTitle, });
  Cookies.set(cookieAlertKey, 'viewed', { expires: 7 , sameSite: 'strict'}); // one-week
}

init();



// WEBPACK FOOTER //
// ./site/html/assets/js/alert-init.js